import { t } from "@lingui/macro";
import * as React from "react";
import { G, Defs, ClipPath, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ClockOutlineIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`Clock Outline`}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="currentColor"
        d="M8 .25a7.75 7.75 0 1 1 0 15.5A7.75 7.75 0 0 1 8 .25Zm0 1.5a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5Zm0 2a.75.75 0 0 1 .75.75v3.19l1.78 1.78a.75.75 0 1 1-1.06 1.06l-2-2A.75.75 0 0 1 7.25 8V4.5A.75.75 0 0 1 8 3.75Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
